import { render, staticRenderFns } from "./IndexHeaderNav.vue?vue&type=template&id=70331cfa&scoped=true&"
import script from "./IndexHeaderNav.vue?vue&type=script&lang=js&"
export * from "./IndexHeaderNav.vue?vue&type=script&lang=js&"
import style0 from "./IndexHeaderNav.vue?vue&type=style&index=0&id=70331cfa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70331cfa",
  null
  
)

export default component.exports